import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdecff9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "top_side_nav" }
const _hoisted_3 = { class: "header_nav" }
const _hoisted_4 = {
  key: 0,
  class: "imgContainer"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "body_nav fade_in"
}
const _hoisted_7 = {
  key: 0,
  class: "footerNav fade_in"
}
const _hoisted_8 = { class: "change_theme" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Desenvolvido por", -1))
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "top_tools_desktop" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "title_default",
  style: {"text-align":"center"}
}, " Você tem certeza que deseja sair da aplicação? ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_menu_icon = _resolveComponent("menu-icon")!
  const _component_user_menu = _resolveComponent("user-menu")!
  const _component_nav_menus = _resolveComponent("nav-menus")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_search_bar = _resolveComponent("search-bar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["mainNav", { active: _ctx.navMobileOpened && _ctx.$store.state.isMobile }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["icon_desktop", { centered: !_ctx.navDesktopOpened && !_ctx.$store.state.isMobile }])
          }, [
            (!_ctx.navDesktopOpened && !_ctx.$store.state.isMobile)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  class: "menu_icon_desktop_right",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleNavDesktop()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" mdi-chevron-right ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.navDesktopOpened && !_ctx.$store.state.isMobile)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 1,
                  class: "menu_icon_desktop_left",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleNavDesktop()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" mdi-chevron-left ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_menu_icon, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleNavBar())),
              navMobileOpened: _ctx.navMobileOpened,
              class: "menu_icon_mobile"
            }, null, 8, ["navMobileOpened"]),
            (_ctx.$store.state.isMobile || _ctx.navDesktopOpened)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", {
                    style: {"cursor":"pointer"},
                    class: "cliente_imagem",
                    src: _ctx.imgCliente,
                    alt: "logo_empresa",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openVisaoGeral()))
                  }, null, 8, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_user_menu, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openUserMenu('mobile'))),
              class: "user_menu_mobile"
            })
          ])
        ]),
        (
          (_ctx.$store.state.isMobile && _ctx.navMobileOpened) || !_ctx.$store.state.isMobile
        )
          ? (_openBlock(), _createElementBlock("nav", _hoisted_6, [
              _createVNode(_component_nav_menus, { navDesktopOpened: _ctx.navDesktopOpened }, null, 8, ["navDesktopOpened"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (
        (_ctx.$store.state.isMobile && _ctx.navMobileOpened) || !_ctx.$store.state.isMobile
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-theme-light-dark")
                ]),
                _: 1
              }),
              _createVNode(_component_v_switch, {
                modelValue: _ctx.changeTheme,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.changeTheme) = $event)),
                inset: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", {
              class: "logout_nav",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loginOut = true))
            }, [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-logout")
                ]),
                _: 1
              }),
              (_ctx.navDesktopOpened)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Sair"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "developed_by",
              style: _normalizeStyle([
          !_ctx.navDesktopOpened && !_ctx.$store.state.isMobile
            ? { width: '0px' }
            : { width: '100%' },
        ])
            }, [
              _hoisted_10,
              _createElementVNode("img", {
                style: {"max-width":"130px"},
                src: _ctx.imgImplanta,
                alt: "logo_empresa"
              }, null, 8, _hoisted_11)
            ], 4)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_search_bar),
      _createVNode(_component_user_menu, {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openUserMenu('desk'))),
        class: "user_menu_desktop"
      })
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.loginOut,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.loginOut) = $event)),
      width: "auto",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "dialog_card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, { style: {"text-align":"center"} }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createVNode(_component_v_btn, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.logout())),
                  rounded: "0",
                  variant: "outlined",
                  color: "var(--app-primary)",
                  style: {"margin":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Sim ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  rounded: "0",
                  class: "text-white",
                  color: "var(--app-primary)",
                  style: {"margin":"5px"},
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loginOut = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Não ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}